/**
 * Rounding to nearest integer. Works the same way as `Math.round` execept 
 * that you can control how many decimals to return
 * 
 * @param value The number value that should be rounded
 * @param decimals How many decimals positions to return. E.g. 2=1.00
 */
export function round(value: number, decimals: number) {
    const exponent = Math.pow(10, decimals);
    return Math.round(value * exponent) / exponent;
}

/**
 * Calculate percentage difference between two values.
 * Returns percentage in range 0-100.
 * 
 * @param value1 
 * @param value2 
 */
export function percentage(value1: number, value2: number) {
    return (value1 / value2) * 100;
}

/**
 * Calculate percentage change between two values. 
 * Example percentageChange(120, 100) returns 20
 * 
 * @param newValue The new value
 * @param previousValue The previous value
 */
export function percentageChange(newValue: number, previousValue: number) {
    return (newValue / previousValue - 1) * 100;
}

/**
 * Returns the sum of all numbers in an array.
 * 
 * @param array An array with numbers
 */
export function sum(array: number[]) {
    return array.reduce((acc, next) => acc + next, 0);
}

/**
 * Returns the average of all numbers in an array.
 * 
 * @param array An array with numbers
 */
export function avg(array: number[]) {
    return sum(array) / array.length;
}
